import * as Icon from '../assets/icons';
import useMediaQuery from '../hooks/media';
import './sociallinks.css';

const SocialLinks = () => {
  const {isXSmall} = useMediaQuery();

  return (
    <div className="social">
      <div className="social-links">
        <a
          className="social__link"
          href="https://www.linkedin.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Linkedin">
          <div className="flexCenter">
            <Icon.Linkedin
              className="social__icon social__icon--1"
              size={isXSmall ? 25 : 35}
            />
          </div>
        </a>
        <a
          className="social__link"
          href="https://www.facebook.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook">
          <div className="flexCenter">
            <Icon.Facebook
              className="social__icon social__icon--2"
              size={isXSmall ? 25 : 35}
            />
          </div>
        </a>
        <a
          className="social__link"
          href="https://www.instagram.com/emetalsanayi/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram">
          <div className="flexCenter">
            <Icon.Instagram
              className="social__icon social__icon--3"
              size={isXSmall ? 25 : 35}
            />
          </div>
        </a>
        <a
          className="social__link"
          href="mailto:info@e-metal.com.tr"
          aria-label="Email Address">
          <div className="flexCenter">
            <Icon.Email
              className="social__icon social__icon--4"
              size={isXSmall ? 30 : 40}
            />
          </div>
        </a>
      </div>
    </div>
  );
};

export default SocialLinks;
